/**
 * useReportRecordLock — komunikat o blokadzie rekordu na czas zadania przycisku SQL dla miejsc,
 * które wołają trasę zablokowaną na czas zadania, ale NIE mają stanu zadań rekordu (listy,
 * przycisk wysyłki, edytor stron dokumentu…). Strona rekordu, która ten stan ma, używa
 * `handleLockedError` z `useRecordProcedureRuns` (pokazuje też pasek blokady).
 *
 * Zwracana funkcja bierze błąd żądania: gdy to 409 `RECORD_LOCKED_BY_RUN` — pokazuje w rogu
 * czytelny komunikat (które zadanie blokuje rekord, od kiedy, czyje) i zwraca `true`; inaczej
 * nic nie robi i zwraca `false` — wołający pokazuje wtedy swój zwykły komunikat błędu.
 */

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/contexts/ToastContext';
import { recordLockReason } from '@/lib/documents/record-lock-reason';

export function useReportRecordLock(): (err: unknown) => boolean {
  const { t, i18n } = useTranslation();
  const toast = useToast();
  return useCallback(
    (err: unknown): boolean => {
      const reason = recordLockReason(err, t, i18n);
      if (reason === null) return false;
      toast.show({ variant: 'error', title: reason });
      return true;
    },
    [t, i18n, toast],
  );
}
